import { Path } from '@/main/router/routerPath';

import { PrehledPov } from './prodej';
import { SkladOjetychVozu } from './skladOjetychVozu';
import { DokladyOjetychVozu } from './dokladyPov';
import { Povzaloha } from './zalohy';

export const router = new Path('OjeteVozyInternal').addChildren([
	SkladOjetychVozu.router,
	PrehledPov.router,
	Povzaloha.router,
	DokladyOjetychVozu.router,
]);
